<template>
    <div class="heading">
        <span>{{ label }}</span>
        <img v-if="toolTip" src="../../assets/question-icon.svg" alt="" @click="openPopup">
    </div>
</template>

<script>
  import tooltipMixin from "../../mixins/tooltipMixin"; //enables tooltips

  export default {
    name: "Label",

    mixins: [tooltipMixin],

    props: {
      label: {
        required: true,
        type: String
      }
    },
    methods: {
      openPopup() {
        this.$store.commit('tooltips/setCurrentActive', this.toolTip);
      }
    }
  }
</script>

<style scoped lang="scss">
    .heading {
       padding-left: 1rem;

      > img {
        cursor: pointer;
        margin-left: 0.5rem;
        transition: all ease 0.3s;

        &:hover {
          transform: scale(1.2);
        }
      }
    }
</style>
